




























































import { Component, Vue } from "vue-property-decorator";
import SlackService from "@/services/slack.service";

@Component
export default class Onboarding extends Vue {
  private hasSubbmitedFormAlready = false;
  private pickedlocale = false;
  private requestForm: {
    name: string;
    email: string;
    phone: string;
    country: string;
    distributor: string;
    tagId: string;
  } = {
    name: "",
    email: "",
    phone: "",
    country: "",
    distributor: "",
    tagId: "",
  };
  private rules = {
    name: [
      { required: true, message: "Please enter a name", trigger: "blur" }
    ],
    phone: [
      { required: true, message: "Please enter a phone number", trigger: "blur" }
    ],
    email: [
      { required: true, message: "Please enter an email", trigger: "blur" }
    ],
    distributor: [
      { required: true, message: "Please enter an distributor", trigger: "blur" }
    ]
  };
  private onSubmit() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        this.hasSubbmitedFormAlready = true;
        const response = await SlackService.sendMessage(this.requestForm);
        if (response) {
          this.$notify.success("Your request has been sent!");
        } else {
          this.$notify.error("Something went wrong, please try again later!");
          this.hasSubbmitedFormAlready = false;
        }
      } else {
        return false;
      }
    });
  }
  private routeToAllsetraOnboarding() {
    window.location.href = "https://onboarding.allsetra.nl/";
  }
}
